<template>
    <!--基本信息-->
    <div>
        <div class="common-form">基本信息</div>
        <div class="table-wrap">
            <el-row>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">商户编号：</span>
                        {{ detail.merchantId }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">商户名称：</span>
                        {{ detail.merchantName }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">设备SN号：</span>
                        {{ detail.snCode }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">姓名：</span>
                        {{ detail.name }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">手机号</span>
                        {{ detail.phoneNo }}
                    </div>
                </el-col>


                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">绑定状态：</span>
                        {{ detail.bindStatus == '0' ? '未绑定' : '已绑定' }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">绑定时间：</span>
                        {{ detail.bindTime }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">设备激活状态：</span>
                        {{ detail.activateStatus == '0' ? '未激活' : '已激活' }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">设备激活时间：</span>
                        {{ detail.activateTime }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
        </div>
    </div>
</template>

<script>
import merchantApi from '@/api/merchant/manage.js';
export default {
    data() {
        return {
            detail: '', // 获取详情信息
        }
    },
    created() {
        this.getParams()
    },
    methods: {
        /*获取参数*/
        getParams() {
            let self = this;
            // 取到路由带过来的参数
            const params = this.$route.query.id;
            // console.log(params)
            merchantApi.getMerchantDetail(
                {
                    id: params
                },
            )
                .then(res => {
                    // console.log(res);
                    self.detail = res.data;
                })
                .catch(error => {
                    // console.log(error);
                });
        },
        // 返回上一页
        cancelFunc() {
            this.$router.back(-1);
        },
    }
}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/merchant/manage/detail.vue